/*
    Background
*/

var background = document.getElementById('settings-background');
var select = document.getElementById('background-color-selector');
var colorPreview = document.getElementById('color-preview-background');
var backgroundTitle = document.getElementById('background-title');
var content = document.getElementsByClassName('content')[0];

var idSelected = 0;

window.updateColorBackground = function() {
    select.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}

select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle['.content']['background-color'] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }

    if (event.target.value == "") {
        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['.content']['background-color'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent";
    }

})